/**
@ngdoc directive
@name editableText

@description
Creates editable text span (you can edit on click).

@param {Object} ng-model ng-model="yourModel" ng-model has to be defined - the text will be assign to it
@param {expression=} editable-text editable-text="expression(yourModel)"
    you may use expression on your model (function, array) to assign to displayed text in case you need something more complex (ie. for &lt;select&gt;)

@usage
Please see testUi (former testValidation) for multiple examples.

*/

(function() {
  'use strict';

var editableText = function($compile, $timeout) {
    return {
        restrict: "A",
        scope: true,
        bindToController:{
            editableText:"&",
            ngModel: "="
        },
        controllerAs:'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            var _this = this;

            if(!angular.isDefined($attrs.ngModel)){
                console.error('editText directive - ng-model not found on:');
                console.error($element);
                // throw "Please define ng-model."; // the exception will be thrown by compile with require ngModel not met
            }

            this.isModelEmpty = function(){
                // model might be undefined or empty string
                return (!angular.isDefined(_this.ngModel) || _this.ngModel=='');
            }

            // initialization
            $scope.editMode = false; // prevent blinking
            $element.hide();
        }],
        replace: false,
        require:["editableText","ngModel"],
        link: function(scope, element, attrs, ctrls) {

            var ctrl = ctrls[0]; // editableText controller

            // initialization
            $timeout(function(){
                if(!angular.isDefined(ctrl.editableText()) || ctrl.editableText()==""){
                    scope.text = ctrl.ngModel;
                } else {
                    scope.text = ctrl.editableText();
                }
                // input hidden by default if only model is not undefined or empty
                scope.editMode = ctrl.isModelEmpty() ? true : false ;
            });

            // insert text span after element
            element.after( $compile('<span tabindex="0" class="editable-text" ng-click="edit($event)" key-press="edit($event)" key-code="13" ng-hide="editMode">{{text}}</span>')(scope) );

            // switch to edit on text (span) click
            scope.edit = function(e){
                e.preventDefault(); // prevent submitting the for once ENTER on IE9- was hit
                scope.editMode = true;
                $timeout(function(){ // needs timeout otherwise firefox fires blur event
                    element.show().focus(); // field focus on edit
                });
            }

            // switch off edition on field blur
            element.on('blur',function(){
                $timeout(function(){ // we need timeout to let update the model before condition check
                    scope.editMode = ctrl.isModelEmpty() ? true : false;
                });
            });

            // if model gets empty at any point go into editable mode (show the form field)
            scope.$watch(
                function(){
                    return ctrl.ngModel;
                },
                function(newVal,oldVal){
                    if(newVal != oldVal){
                        if(!angular.isDefined(ctrl.editableText()) || ctrl.editableText()==""){
                            scope.text = ctrl.ngModel;
                        } else {
                            scope.text = ctrl.editableText();
                        }
                        if(ctrl.isModelEmpty()){
                            scope.editMode = true;
                        }
                    }
                }
            );

            // this is exactly the same as ng-show="editMode"
            scope.$watch('editMode', function(newVal, oldVal){
                if(newVal != oldVal){
                    if(newVal){
                        element.show();
                    } else {
                        element.hide();
                    }
                }
            });

        }
    };
}
editableText.$inject = ['$compile', '$timeout'];
angular.module('app').directive('editableText', editableText);

}());
